import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KMosaicElementNoBackground";
var classes = {
    container: "".concat(PREFIX, "-container"),
    typography: "".concat(PREFIX, "-typography")
};
var StyledKMosaicElementNoBackground = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            overflow: "hidden",
            height: "100%",
            width: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            background: theme.palette.background.paper
        },
        _b["& .".concat(classes.container)] = {
            width: "200%",
            height: "200%",
            transform: "rotate(-20deg) translateX(-50%) translateY(-50%)",
            position: "absolute",
            left: "50%",
            top: "50%",
            opacity: 0.87
        },
        _b["& .".concat(classes.typography)] = {
            color: theme.palette.divider,
            lineHeight: 1,
            wordBreak: "break-all",
            textTransform: "uppercase"
        },
        _b);
});

export { classes, StyledKMosaicElementNoBackground as default };
//# sourceMappingURL=index.styled.js.map
